import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("textarea", {
    class: _normalizeClass(`${
      _ctx.isEditable ? '' : 'cursor-auto'
    }  w-full border  px-3 py-2 resize-none font-mono text-sm focus:outline-none`),
    disabled: !_ctx.isEditable,
    value: _ctx.value,
    wrap: "off",
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeText && _ctx.changeText(...args)))
  }, null, 42, _hoisted_1))
}